import { addDays, niceDate } from './format';

// Pay periods for the Accounting pages. The POS has no pay-period concept
// (its timesheet is a free date range), so this is purely a picker
// convenience driven by the store's accounting profile:
//   weekly / biweekly  — stepped from `anchorDate` (a known period start)
//   semimonthly        — 1st–15th and 16th–end of month
//   monthly            — calendar month
// Dates are 'YYYY-MM-DD' strings; arithmetic is done in UTC so DST never
// shifts a boundary.

const DAY_MS = 24 * 60 * 60 * 1000;
const ms = (iso) => Date.parse(iso + 'T00:00:00Z');
const iso = (m) => new Date(m).toISOString().slice(0, 10);
const ymd = (iso) => iso.split('-').map(Number);

export function periodContaining(dateISO, cfg = {}) {
  const type = cfg.type || 'monthly';
  const anchorDate = cfg.anchorDate || '2026-01-05';
  const [y, m, d] = ymd(dateISO);
  if (type === 'monthly') {
    return { type, anchorDate, start: iso(Date.UTC(y, m - 1, 1)), end: iso(Date.UTC(y, m, 0)) };
  }
  if (type === 'semimonthly') {
    return d <= 15
      ? { type, anchorDate, start: iso(Date.UTC(y, m - 1, 1)), end: iso(Date.UTC(y, m - 1, 15)) }
      : { type, anchorDate, start: iso(Date.UTC(y, m - 1, 16)), end: iso(Date.UTC(y, m, 0)) };
  }
  const len = type === 'weekly' ? 7 : 14;
  const a = ms(anchorDate);
  const k = Math.floor((ms(dateISO) - a) / (len * DAY_MS));
  const start = a + k * len * DAY_MS;
  return { type, anchorDate, start: iso(start), end: iso(start + (len - 1) * DAY_MS) };
}

// The period before (-1) or after (+1) this one.
export const shiftPeriod = (period, dir) => periodContaining(
  dir > 0 ? addDays(period.end, 1) : addDays(period.start, -1),
  period,
);

export function periodLabel(period) {
  if (period.type === 'monthly') {
    return new Date(period.start + 'T12:00:00Z').toLocaleDateString('en-CA', { month: 'long', year: 'numeric', timeZone: 'UTC' });
  }
  return `${niceDate(period.start)} – ${niceDate(period.end)}`;
}
